<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">结算单名称</span>
        <Input v-model="searchParams.reportName" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" :isTopCheck="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">未结算</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="addNewReport">新建结算单</Button>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reportName">
          <span class="table-btn" @click="toDetailPage(row)">{{ row.reportName }}</span>
        </template>

        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">未结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="delRow(row)" v-if="row.settlementStatus == 0">删除</span>
          <span class="table-btn" @click="payment(row)" v-if="row.settlementStatus == 1 && row.payStatus == 0">付款</span>
          <span class="table-btn" @click="payment(row)" v-if="row.settlementStatus == 1 && row.payStatus == 1">取消付款</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>

    <payPopUp ref="payPopUpRef" @change-pay="getList"></payPopUp>
  </div>
</template>

<script>
import payPopUp from './components/payPopUp';
import selectTree from '@/components/system/selectTree3';
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    payPopUp
  },
  data() {
    return {
      searchParams: {},
      columns: [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          align: 'center',
          minWidth: 210,
          slot: 'reportName'
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '批单数',
          align: 'center',
          key: 'billNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 130
        },
        {
          title: '费用费用合计',
          align: 'center',
          key: 'netIncome',
          minWidth: 120
        },
        {
          title: '是否已付款',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let payStatus = params.row.payStatus;
            return <span>{payStatus == 0 ? '未付款' : '已付款'}</span>;
          },
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否付款</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>是否已对机构付款</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 140,
          fixed: 'right'
        }
      ],
      total: 0,
      tableData: []
    };
  },
  activated(){
    this.getList();
  },
  created() {
    this.searchAjax();
  },
  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    resetSearch() {
      this.searchParams = {};
      this.searchAjax();
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;
      this.$http({
        url: '/buz/settlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 3
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 新建结算报表
    addNewReport() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/newReport', { isAdd: 1, step: '1', reportName: '新建结算单', time: Date.now() });
    },

    toDetailPage(row) {
      if (row.step == '1') {
        this.openPageTabTags('/orgSettlement/groupCommissionSettlement/editReport', {
          reportId: row.id,
          isAdd: 0,
          step: '1',
          reportName: row.reportName
        });
      } else {
        this.openPageTabTags('/orgSettlement/groupCommissionSettlement/editReport', {
          reportId: row.id,
          step: row.step,
          reportName: row.reportName,
          settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD') //结算日期
        });
      }
    },

    // 删除
    delRow(row) {
      if (!this.$units.pointAction('offline_82_3_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/settlementReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },

    // 付款/取消付款
    payment(row) {
      if (!this.$units.pointAction('offline_82_3_6')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.payPopUpRef.open(row.payStatus, row.id)
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}

.label {
  position: relative;
  .tip-icon {
    margin-left: 6px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -38px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 66px;
      transform: rotateZ(135deg);
    }
  }
}
</style>